module.exports = __webpack_public_path__ + "static/media/greenCheck.358d5979.svg";